<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>

    <li class="breadcrumb-item active" aria-current="page">
      {{ "Form.UsageAnalytics" | translate }}
    </li>
  </ol>
</nav>

<div *ngIf="isLoading; else notLoading" class="loaderdata">
  <div class="spinner-border" role="status">
    <span class="sr-only">{{ "Form.Loading" | translate }}</span>
  </div>
</div>

<ng-template #notLoading>
  <div class="row" style="margin-top: 25px">
    <div
      class="card d-flex text-left"
      style="margin: 0px 16px 30px 16px; padding: 20px; width: 100%"
    >
      <div class="row">
        <div class="col-lg-3 col-md-12 col-sm-12">
          <div class="card-title text-capitalize mb-0">
            Project:<span class="text-danger">*</span>
          </div>
          <select
            name="project"
            class="form-control"
            [(ngModel)]="filter.selectedProject"
            style="height: 35px !important; width: 100%"
            (change)="applyFilter(true)"
          >
            <option *ngFor="let item of data" [value]="item?.id">
              {{ item?.name }}
            </option>
          </select>
        </div>
        <div class="col-lg-3 col-md-12 col-sm-12">
          <div class="card-title text-capitalize mb-0">
            Version:<span class="text-danger">*</span>
          </div>
          <select
            name="version"
            class="form-control"
            [(ngModel)]="filter.selectedVersion"
            style="height: 35px !important; width: 100%"
            (change)="applyFilter(false)"
          >
            <option *ngFor="let item of versionList" [value]="item?.id">
              {{ item?.version }} ({{
                item?.releaseDate | date : "dd MMM yyyy"
              }})
            </option>
          </select>
        </div>
        <div class="col-lg-3 col-md-12 col-sm-12">
          <div class="card-title text-capitalize mb-0">
            Start Date:<span class="text-danger">*</span>
          </div>
          <input
            name="startDate"
            type="date"
            [(ngModel)]="filter.startDate"
            placeholder="Filter by Start Date"
            style="background-color: rgba(0, 0, 0, 0.03) !important"
            class="form-control"
            (input)="applyFilter(false)"
          />
        </div>
        <div class="col-lg-3 col-md-12 col-sm-12">
          <div class="card-title text-capitalize mb-0">
            End Date:<span class="text-danger">*</span>
          </div>
          <input
            name="endDate"
            type="date"
            [(ngModel)]="filter.endDate"
            placeholder="Filter by End Date"
            style="background-color: rgba(0, 0, 0, 0.03) !important"
            class="form-control"
            (input)="applyFilter(false)"
          />
        </div>
      </div>
    </div>

    <!-- Main Tab: Analytics / Insights -->
    <div style="margin: 0 16px 0 16px; width: 100%;">
      <ul class="nav nav-tabs" style="border-bottom: 2px solid #dee2e6;">
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeMainTab === 0"
             style="cursor:pointer; font-weight:500;"
             (click)="onMainTabChange(0)">Analytics</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="activeMainTab === 1"
             style="cursor:pointer; font-weight:500;"
             (click)="onMainTabChange(1)">Insights</a>
        </li>
      </ul>
    </div>

    <!-- Insights Tab -->
    <div *ngIf="activeMainTab === 1" style="margin: 16px; width: 100%;">
      <div class="card" style="padding: 20px; margin-bottom: 16px;">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
            <label style="font-weight:500;">Screen</label>
            <select class="form-control" style="height:35px;"
              [(ngModel)]="insightsFilter.screenManagementId"
              (change)="loadChatInsights()">
              <option value="">All Screens</option>
              <option *ngFor="let s of insightsScreenList" [value]="s.id">{{s.name}}</option>
            </select>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 mb-2">
            <label style="font-weight:500;">Module</label>
            <select class="form-control" style="height:35px;"
              [(ngModel)]="insightsFilter.moduleId"
              (change)="loadChatInsights()">
              <option value="">All Modules</option>
              <option *ngFor="let m of insightsModuleList" [value]="m.id">{{m.name}}</option>
            </select>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-12 mb-2 d-flex align-items-end">
            <button class="btn btn-outline-secondary" style="height:35px;" (click)="insightsFilter={screenManagementId:'',moduleId:''};loadChatInsights()">Clear</button>
          </div>
        </div>
      </div>

      <div *ngIf="insightsLoading" class="text-center py-4">
        <div class="spinner-border text-primary" role="status"></div>
      </div>

      <div *ngIf="!insightsLoading && insightsData.length === 0" class="card" style="padding:40px; text-align:center; color:#6c757d;">
        No chat insights found for the selected filters.
      </div>

      <div *ngIf="!insightsLoading && insightsData.length > 0" class="card" style="padding:0; overflow:hidden;">
        <table class="table table-hover mb-0" style="font-size:13px;">
          <thead style="background:#f8f9fa; font-weight:600;">
            <tr>
              <th style="width:18%; padding:12px 16px;">Date</th>
              <th style="width:12%;">Screen</th>
              <th style="width:12%;">Module</th>
              <th style="width:12%;">Doc Type</th>
              <th style="width:22%;">Query (Context)</th>
              <th style="width:24%;">Answer / Doc Ref</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of insightsData">
              <td style="padding:10px 16px; vertical-align:top; color:#6c757d; font-size:12px;">
                {{item.created | date:'dd MMM yyyy, HH:mm'}}
              </td>
              <td style="vertical-align:top;">
                <span class="badge" style="background:#e8f4fd; color:#1976d2; padding:4px 8px; border-radius:4px; font-size:11px; white-space:nowrap;">
                  {{item.screenName || '—'}}
                </span>
              </td>
              <td style="vertical-align:top;">
                <span style="font-size:12px; color:#555;">{{item.moduleName || '—'}}</span>
              </td>
              <td style="vertical-align:top;">
                <span class="badge"
                  [style.background]="item.docType==='userguide'?'#e8f5e9':item.docType==='FAQ'?'#fff3e0':'#fce4ec'"
                  [style.color]="item.docType==='userguide'?'#2e7d32':item.docType==='FAQ'?'#e65100':'#880e4f'"
                  style="padding:4px 8px; border-radius:4px; font-size:11px;">
                  {{item.docType}}
                </span>
              </td>
              <td style="vertical-align:top; max-width:220px;">
                <div style="font-weight:500; color:#333; margin-bottom:4px;">{{item.query}}</div>
                <div style="color:#666; font-size:11px; line-height:1.4; max-height:60px; overflow:hidden; text-overflow:ellipsis;">
                  {{item.context}}
                </div>
              </td>
              <td style="vertical-align:top; max-width:240px;">
                <div *ngIf="item.answer" style="font-size:11px; color:#333; line-height:1.5; max-height:80px; overflow:hidden;"
                  [innerHTML]="item.answer.slice(0,300)"></div>
                <div style="margin-top:6px;">
                  <span style="font-size:11px; color:#888;">Doc: </span>
                  <span style="font-size:11px; font-weight:500; color:#1976d2;">{{item.docName}}</span>
                </div>
                <div style="margin-top:2px; font-size:11px; color:#aaa;">
                  Score: {{item.similarityScore | number:'1.2-4'}}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Analytics Tab (existing content) -->
    <div *ngIf="activeMainTab === 0">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 project-box">
        <div class="card-hover-shadow-2x mb-3 card">
          <div class="card-header-tab card-header">
            <div class="card-title text-capitalize mb-0">
              {{ "Form.UsageAnalyticBarChart" | translate }}
            </div>
          </div>
          <div>
            <div
              lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
            >
              <div class="mb-3">
                <div class="g-0 col" style="height: max-content">
                  <div style="height: 100%; margin: 30px">
                    <apx-chart
                      [series]="usageDataBarChart?.series"
                      [chart]="{
                        height: '500',
                        type: 'bar'
                      }"
                      [stroke]="{
                        show: true,
                        width: 2,
                        colors: ['transparent']
                      }"
                      [plotOptions]="{
                        bar: {
                          horizontal: false,
                          endingShape: 'rounded',
                          columnWidth: '25%'
                        }
                      }"
                      [dataLabels]="{
                        enabled: true
                      }"
                      [xaxis]="{
                        categories: usageDataBarChart?.categories
                      }"
                      [yaxis]="{
                        title: {
                          text: 'Counts'
                        }
                      }"
                      [fill]="{
                        opacity: 1
                      }"
                    ></apx-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 project-box">
        <div class="card-hover-shadow-2x mb-3 card">
          <div class="card-header-tab card-header">
            <div class="card-title text-capitalize mb-0">
              {{ "Form.SWA" | translate }} here
            </div>
          </div>
          <div>
            <div
              lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
            >
              <div class="mb-3">
                <div class="g-0 col" style="height: max-content">
                  <div style="height: 100%; margin: 30px">
                    <apx-chart
                      [series]="chartOptionsforScreenwiseQueries?.series"
                      [chart]="chartOptionsforScreenwiseQueries?.chart"
                      [xaxis]="chartOptionsforScreenwiseQueries?.xaxis"
                      [yaxis]="chartOptionsforScreenwiseQueries?.yaxis"
                      [stroke]="chartOptionsforScreenwiseQueries?.stroke"
                      [plotOptions]="
                        chartOptionsforScreenwiseQueries?.plotOptions
                      "
                      [colors]="chartOptionsforScreenwiseQueries?.colors"
                    >
                    </apx-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Asked Questions in past 6 months -->

    <div class="col-lg-12 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div
          class="card-header-tab mt-2 card-header flex-column align-items-start"
        >
          <div class="card-title text-capitalize mb-0">Query Analytics</div>
          <div class="card-subtitle text-capitalize mb-0">
            Data from the past 6 months (since
            {{ filter.startDate | date : "MMMM d, y" }})
          </div>
        </div>
        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0 col" style="height: max-content">
                <div style="height: 100%; margin: 30px">
                  <div id="chart">
                    <apx-chart
                      class="monthwise-queries"
                      [series]="chartOptionsForpastQueriesData?.series"
                      [chart]="chartOptionsForpastQueriesData?.chart"
                      [xaxis]="chartOptionsForpastQueriesData?.xaxis"
                      [yaxis]="chartOptionsForpastQueriesData?.yaxis"
                      [stroke]="chartOptionsForpastQueriesData?.stroke"
                      [plotOptions]="
                        chartOptionsForpastQueriesData?.plotOptions
                      "
                      [colors]="chartOptionsForpastQueriesData?.colors"
                    >
                    </apx-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.TAW" | translate }}
          </div>

          <!--   <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content); fetchAllData('top5thumbsUpRefTypeWorkflowData')
              "
            >
              View All
            </button>
          </div> -->
        </div>
        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let singleWorkflow of mostAccessedData?.workflow"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="
                          openUsageAnalyticDetail(singleWorkflow, 'chat')
                        "
                        title="{{ singleWorkflow?.docName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ singleWorkflow?.docName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ singleWorkflow?.count || 0 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!mostAccessedData?.workflow"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.TAFAQ" | translate }}
          </div>

          <!--   <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content); fetchAllData('top5thumbsUpRefTypeWorkflowData')
              "
            >
              View All
            </button>
          </div> -->
        </div>
        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let singleFaq of mostAccessedData?.FAQ"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(singleFaq, 'chat')"
                        title="{{ singleFaq?.docName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ singleFaq?.docName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ singleFaq?.count || 0 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!mostAccessedData?.FAQ"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header d-flex justify-content-between">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.TAUG" | translate }}
          </div>
        </div>
        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let singleuserguide of mostAccessedData?.userguide"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="
                          openUsageAnalyticDetail(singleuserguide, 'chat')
                        "
                        title="{{ singleuserguide?.docName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ singleuserguide?.docName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ singleuserguide?.count || 0 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!mostAccessedData?.singleuserguide"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.TopusefulWorkflow" | translate }}
          </div>

          <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content); fetchAllData('top5thumbsUpRefTypeWorkflowData')
              "
            >
              View All
            </button>
          </div>
        </div>

        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let f of feedback?.top5thumbsUpRefTypeWorkflowData"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(f)"
                        title="{{ f.refName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ f.refName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ f.thumbsUpCount || 0 }}
                              <i
                                aria-hidden="true"
                                class="fa fa-thumbs-up"
                                style="color: #5a5a5a; margin: 5px 5px"
                                title="Useful"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!feedback?.top5thumbsUpRefTypeWorkflowData?.length"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.TopusefulFAQ" | translate }}
          </div>

          <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content); fetchAllData('top5thumbsUpRefTypeFAQData')
              "
            >
              View All
            </button>
          </div>
        </div>

        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let f of feedback?.top5thumbsUpRefTypeFAQData"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(f)"
                        title="{{ f.refName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ f.refName }}eeee
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ f.thumbsUpCount || 0 }}
                              <i
                                aria-hidden="true"
                                class="fa fa-thumbs-up"
                                style="color: #5a5a5a; margin: 5px 5px"
                                title="Useful"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!feedback?.top5thumbsUpRefTypeFAQData?.length"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.TopusefulUG" | translate }}
          </div>

          <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content); fetchAllData('top5thumbsUpRefTypeUserguideData')
              "
            >
              View All
            </button>
          </div>
        </div>

        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0 col" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let f of feedback?.top5thumbsUpRefTypeUserguideData"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(f)"
                        title="{{ f.refName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ f.refName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ f.thumbsUpCount || 0 }}
                              <i
                                aria-hidden="true"
                                class="fa fa-thumbs-up"
                                style="color: #5a5a5a; margin: 5px 5px"
                                title="Useful"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!feedback?.top5thumbsUpRefTypeUserguideData?.length"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.Topnneedimprovementworkflow" | translate }}
          </div>

          <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content); fetchAllData('top5thumbsDownRefTypeWorkflowData')
              "
            >
              View All
            </button>
          </div>
        </div>

        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0 col" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let f of feedback?.top5thumbsDownRefTypeWorkflowData"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(f)"
                        title="{{ f.refName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ f.refName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ f.thumbsDownCount || 0 }}
                              <i
                                aria-hidden="true"
                                class="fa fa-thumbs-down"
                                style="color: #5a5a5a; margin: 5px 5px"
                                title="Useful"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!feedback?.top5thumbsDownRefTypeWorkflowData?.length"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.TopnneedimprovementFAQ" | translate }}
          </div>

          <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content); fetchAllData('top5thumbsDownRefTypeFAQData')
              "
            >
              View All
            </button>
          </div>
        </div>

        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0 col" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let f of feedback?.top5thumbsDownRefTypeFAQData"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(f)"
                        title="{{ f.refName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ f.refName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ f.thumbsDownCount || 0 }}
                              <i
                                aria-hidden="true"
                                class="fa fa-thumbs-down"
                                style="color: #5a5a5a; margin: 5px 5px"
                                title="Useful"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!feedback?.top5thumbsDownRefTypeFAQData?.length"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.Topnneedimprovementuserguide" | translate }}
          </div>

          <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content);
                fetchAllData('top5thumbsDownRefTypeUserguideData')
              "
            >
              View All
            </button>
          </div>
        </div>

        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0 col" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let f of feedback?.top5thumbsDownRefTypeUserguideData"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(f)"
                        title="{{ f.refName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ f.refName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ f.thumbsDownCount || 0 }}
                              <i
                                aria-hidden="true"
                                class="fa fa-thumbs-down"
                                style="color: #5a5a5a; margin: 5px 5px"
                                title="Useful"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!feedback?.top5thumbsDownRefTypeUserguideData?.length"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.Topratingworkflow" | translate }}
          </div>

          <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content); fetchAllData('top5RatingsRefTypeWorkflowData')
              "
            >
              View All
            </button>
          </div>
        </div>

        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0 col" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let f of feedback?.top5RatingsRefTypeWorkflowData"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(f)"
                        title="{{ f.refName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ f.refName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ f.ratingCount || 0 }}
                              <i
                                aria-hidden="true"
                                class="fa fa-star"
                                style="color: #5a5a5a; margin: 5px 5px"
                                title="Useful"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!feedback?.top5RatingsRefTypeWorkflowData?.length"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.TopratingFAQ" | translate }}
          </div>

          <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="open(content); fetchAllData('top5RatingsRefTypeFAQData')"
            >
              View All
            </button>
          </div>
        </div>

        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0 col" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let f of feedback?.top5RatingsRefTypeFAQData"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(f)"
                        title="{{ f.refName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ f.refName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ f.ratingCount || 0 }}
                              <i
                                aria-hidden="true"
                                class="fa fa-star"
                                style="color: #5a5a5a; margin: 5px 5px"
                                title="Useful"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!feedback?.top5RatingsRefTypeFAQData?.length"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.Topratinguserguide" | translate }}
          </div>

          <div class="btn-actions-pane-right text-capitalize actions-icon-btn">
            <button
              class="btn btn-icon"
              (click)="
                open(content); fetchAllData('top5RatingsRefTypeUserguideData')
              "
            >
              View All
            </button>
          </div>
        </div>

        <div>
          <div
            lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
          >
            <div class="mb-3">
              <div class="g-0 col" style="height: 310px; overflow-y: auto;">
                <div
                  class="col-md-12 col-lg-12"
                  *ngFor="let f of feedback?.top5RatingsRefTypeUserguideData"
                >
                  <ul class="list-group list-group-flush">
                    <li class="bg-transparent list-group-item">
                      <div
                        class="widget-content"
                        (click)="openUsageAnalyticDetail(f)"
                        title="{{ f.refName }}"
                      >
                        <div class="widget-content-outer">
                          <div class="widget-content-wrapper">
                            <div
                              class="widget-content-left"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <div
                                class="widget-heading"
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                "
                              >
                                {{ f.refName }}
                              </div>
                            </div>
                            <div
                              class="widget-content-right"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ f.ratingCount || 0 }}
                              <i
                                aria-hidden="true"
                                class="fa fa-star"
                                style="color: #5a5a5a; margin: 5px 5px"
                                title="Useful"
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  style="text-align: center; padding: 20px"
                  *ngIf="!feedback?.top5RatingsRefTypeUserguideData.length"
                >
                  <strong>No Data Available</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div><!-- end 12-card row -->
    <div class="col-lg-12 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card">
        <div class="card-header-tab card-header d-flex justify-content-between">
          <div class="card-title text-capitalize mb-0">
            {{ "Form.UsageAnalyticSunBurstChart" | translate }}
          </div>
          <button class="btn btn-link" (click)="openFullAnalytics()">
            View All
          </button>
        </div>
        <mat-tab-group animationDuration="200ms">
          <mat-tab label="Usage Analytic Chart">
            <div>
              <div
                class="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
              >
                <div class="mb-3">
                  <div class="g-0 col" style="height: max-content">
                    <div
                      id="usageanalytic-legend"
                      style="margin: 20px; height: 200px"
                    ></div>
                    <div
                      #usageanalyticChart
                      id="usageanalytic-chart"
                      style="flex: 1; height: 100%; margin: -115px 0px 30px 445px"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Table Data">
            <app-nav-tree [data]="navTreeData"></app-nav-tree>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>

    <!-- Page Navigation Patterns -->
    <div class="col-lg-12 col-md-12 col-sm-12 project-box">
      <div class="card-hover-shadow-2x mb-3 card" style="overflow:visible">
        <div class="card-header-tab card-header d-flex justify-content-between">
          <div class="card-title text-capitalize mb-0">Page Navigation Patterns</div>
        </div>
        <div style="overflow:visible">
          <app-nav-flow [filterQuery]="buildFilterQuery()"></app-nav-flow>
        </div>
      </div>
    </div>
    </div><!-- /Analytics tab -->

  </div>
</ng-template>

<ng-template
  #content
  let-modal
  class="main-card mb-3 col-md-6 col-xl-4 mx-auto card add-edit-user"
>
  <div class="modal-header">
    <h4
      class="modal-title"
      id="modal-basic-title"
      *ngIf="key == 'top5thumbsUpRefTypeWorkflowData'"
    >
      {{ "Form.UsefulWorkflow" | translate }}
    </h4>
    <h4
      class="modal-title"
      id="modal-basic-title"
      *ngIf="key == 'top5thumbsDownRefTypeWorkflowData'"
    >
      {{ "Form.Needimprovementworkflow" | translate }}
    </h4>
    <h4
      class="modal-title"
      id="modal-basic-title"
      *ngIf="key == 'top5thumbsUpRefTypeFAQData'"
    >
      {{ "Form.UsefulFAQ" | translate }}
    </h4>
    <h4
      class="modal-title"
      id="modal-basic-title"
      *ngIf="key == 'top5thumbsDownRefTypeFAQData'"
    >
      {{ "Form.NeedimprovementFAQ" | translate }}
    </h4>
    <h4
      class="modal-title"
      id="modal-basic-title"
      *ngIf="key == 'top5thumbsUpRefTypeUserguideData'"
    >
      {{ "Form.UsefulUG" | translate }}
    </h4>
    <h4
      class="modal-title"
      id="modal-basic-title"
      *ngIf="key == 'top5thumbsDownRefTypeUserguideData'"
    >
      {{ "Form.Needimprovementuserguide" | translate }}
    </h4>
    <h4
      class="modal-title"
      id="modal-basic-title"
      *ngIf="key == 'top5RatingsRefTypeWorkflowData'"
    >
      {{ "Form.Ratingworkflow" | translate }}
    </h4>
    <h4
      class="modal-title"
      id="modal-basic-title"
      *ngIf="key == 'top5RatingsRefTypeFAQData'"
    >
      {{ "Form.RatingFAQ" | translate }}
    </h4>
    <h4
      class="modal-title"
      id="modal-basic-title"
      *ngIf="key == 'top5RatingsRefTypeUserguideData'"
    >
      {{ "Form.Ratinguserguide" | translate }}
    </h4>
    <button
      type="button"
      class="close mt-2"
      aria-label="close"
      (click)="modal.dismiss('Cross click')"
    >
      &times;
    </button>
  </div>
  <div class="modal-body">
    <div class="">
      <div class="card-body pt-0 ps-1">
        <div *ngIf="key == 'top5thumbsUpRefTypeWorkflowData'">
          <div
            style="margin-bottom: 5px"
            *ngFor="let f of allData.top5thumbsUpRefTypeWorkflowData"
          >
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <div>{{ f.refName }}</div>
                      <div>
                        {{ f.ratingCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-star"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f.thumbsUpCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-up"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f.thumbsDownCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-down"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-usage-analytic-details
                  [data]="f"
                ></app-usage-analytic-details>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div
            *ngIf="!allData?.top5thumbsUpRefTypeWorkflowData?.length"
            style="text-align: center"
          >
            <strong>No Data Available</strong>
          </div>
        </div>
        <div *ngIf="key == 'top5thumbsDownRefTypeWorkflowData'">
          <div
            style="margin-bottom: 5px"
            *ngFor="let f of allData?.top5thumbsDownRefTypeWorkflowData"
          >
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <div>{{ f?.refName }}</div>
                      <div>
                        {{ f?.ratingCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-star"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsUpCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-up"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsDownCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-down"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-usage-analytic-details
                  [data]="f"
                ></app-usage-analytic-details>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div
            *ngIf="!allData?.top5thumbsDownRefTypeWorkflowData?.length"
            style="text-align: center"
          >
            <strong>No Data Available</strong>
          </div>
        </div>
        <div *ngIf="key == 'top5thumbsUpRefTypeFAQData'">
          <div
            style="margin-bottom: 5px"
            *ngFor="let f of allData?.top5thumbsUpRefTypeFAQData"
          >
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <div>{{ f?.refName }}</div>
                      <div>
                        {{ f?.ratingCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-star"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsUpCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-up"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsDownCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-down"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-usage-analytic-details
                  [data]="f"
                ></app-usage-analytic-details>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div
            *ngIf="!allData?.top5thumbsUpRefTypeFAQData?.length"
            style="text-align: center"
          >
            <strong>No Data Available</strong>
          </div>
        </div>
        <div *ngIf="key == 'top5thumbsDownRefTypeFAQData'">
          <div
            style="margin-bottom: 5px"
            *ngFor="let f of allData?.top5thumbsDownRefTypeFAQData"
          >
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <div>{{ f?.refName }}</div>
                      <div>
                        {{ f?.ratingCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-star"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsUpCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-up"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsDownCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-down"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-usage-analytic-details
                  [data]="f"
                ></app-usage-analytic-details>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div
            *ngIf="!allData?.top5thumbsDownRefTypeFAQData?.length"
            style="text-align: center"
          >
            <strong>No Data Available</strong>
          </div>
        </div>
        <div *ngIf="key == 'top5thumbsUpRefTypeUserguideData'">
          <div
            style="margin-bottom: 5px"
            *ngFor="let f of allData?.top5thumbsUpRefTypeUserguideData"
          >
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <div>{{ f?.refName }}</div>
                      <div>
                        {{ f?.ratingCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-star"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsUpCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-up"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsDownCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-down"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-usage-analytic-details
                  [data]="f"
                ></app-usage-analytic-details>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div
            *ngIf="!allData?.top5thumbsUpRefTypeUserguideData?.length"
            style="text-align: center"
          >
            <strong>No Data Available</strong>
          </div>
        </div>
        <div *ngIf="key == 'top5thumbsDownRefTypeUserguideData'">
          <div
            style="margin-bottom: 5px"
            *ngFor="let f of allData?.top5thumbsDownRefTypeUserguideData"
          >
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <div>{{ f?.refName }}</div>
                      <div>
                        {{ f?.ratingCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-star"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsUpCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-up"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsDownCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-down"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-usage-analytic-details
                  [data]="f"
                ></app-usage-analytic-details>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div
            *ngIf="!allData?.top5thumbsDownRefTypeUserguideData?.length"
            style="text-align: center"
          >
            <strong>No Data Available</strong>
          </div>
        </div>
        <div *ngIf="key == 'top5RatingsRefTypeWorkflowData'">
          <div
            style="margin-bottom: 5px"
            *ngFor="let f of allData?.top5RatingsRefTypeWorkflowData"
          >
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <div>{{ f?.refName }}</div>
                      <div>
                        {{ f?.ratingCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-star"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsUpCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-up"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsDownCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-down"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-usage-analytic-details
                  [data]="f"
                ></app-usage-analytic-details>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div
            *ngIf="!allData?.top5RatingsRefTypeWorkflowData?.length"
            style="text-align: center"
          >
            <strong>No Data Available</strong>
          </div>
        </div>
        <div *ngIf="key == 'top5RatingsRefTypeFAQData'">
          <div
            style="margin-bottom: 5px"
            *ngFor="let f of allData?.top5RatingsRefTypeFAQData"
          >
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <div>{{ f?.refName }}</div>
                      <div>
                        {{ f?.ratingCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-star"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsUpCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-up"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsDownCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-down"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-usage-analytic-details
                  [data]="f"
                ></app-usage-analytic-details>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div
            *ngIf="!allData?.top5RatingsRefTypeFAQData?.length"
            style="text-align: center"
          >
            <strong>No Data Available</strong>
          </div>
        </div>
        <div *ngIf="key == 'top5RatingsRefTypeUserguideData'">
          <div
            style="margin-bottom: 5px"
            *ngFor="let f of allData?.top5RatingsRefTypeUserguideData"
          >
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                      "
                    >
                      <div>{{ f?.refName }}</div>
                      <div>
                        {{ f?.ratingCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-star"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsUpCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-up"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                        {{ f?.thumbsDownCount || 0 }}
                        <i
                          aria-hidden="true"
                          class="fa fa-thumbs-down"
                          style="color: #5a5a5a; margin: 5px 5px"
                          title="Useful"
                        ></i>
                      </div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-usage-analytic-details
                  [data]="f"
                ></app-usage-analytic-details>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <div
            *ngIf="!allData?.top5RatingsRefTypeUserguideData?.length"
            style="text-align: center"
          >
            <strong>No Data Available</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #querymodal let-modal let-d="dismiss" let-c="close">
  <div class="modal-header">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="modal-title ms-2 mb-0">
        Query Asked in Month of {{ popupMoth }}
      </h4>
      <button
        type="button"
        class="close mt-2"
        aria-label="Close"
        (click)="d('Cross click')"
        style="border: none !important"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="card-body pt-0 ps-1">
      <table
        class="align-middle mb-0 table table-borderless table-striped table-hover"
      >
        <thead class="font-size-lg text-white">
          <tr>
            <th>
              <div class="d-flex justify-content-between align-items-center">
                Query
              </div>
            </th>
            <th>
              <div class="d-flex justify-content-between align-items-center">
                Screen Name
              </div>
            </th>
            <th>
              <div class="d-flex justify-content-between align-items-center">
                <!-- {{ "Form.moduleName" | translate }} -->
                Count
              </div>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="tableData?.length; else noData">
          <tr *ngFor="let item of tableData; let i = index">
            <td>{{ item?.query }}</td>
            <td>{{ item?.screenName }}</td>
            <td>{{ item?.count }}</td>
          </tr>
        </tbody>
        <ng-template #noData>
          <tbody>
            <tr>
              <td colspan="7" class="text-center">
                {{ "Form.NoDataAvailable" | translate }}
              </td>
            </tr>
          </tbody>
        </ng-template>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #visitedPagesTree let-modal let-d="dismiss" let-c="close">
  <div class="modal-header d-flex justify-content-between">
    <div class="mt-2">
      <h5>Visitor flow</h5>
    </div>
    <div>
      <button
        class="btn bg-transparent text-dark close mt-2"
        style="font-size: 35px; border: none !important"
        (click)="modal.dismiss('Cross click')"
      >
        &times;
      </button>
    </div>
  </div>
  <div class="modal-body">
    <visited-pages></visited-pages>
  </div>
</ng-template>
